export default function registerAdminEventTypeDirective(module) {
    /**
     * Registers the 'adminEventType' directive with the provided module.
     * 
     * @param {object} module - The AngularJS module to register the directive with.
     */
    module.directive('adminEventType', function() {
        return {
            restrict: 'E', // Restricts the directive to element usage only.
            replace: true, // Replaces the element with the template.
            templateUrl: '/views/ib/modules/invigilatorMenu/AdminEventTypeDirective.html', // Path to the directive's template.
            controller: AdminEventTypeController, // Controller for the directive.
            scope: {
                type: "@", // One-way binding for the 'type' attribute.
                eventId: "@", // One-way binding for the 'eventId' attribute.
                emptyReasonOption: "=", // Two-way binding for the 'emptyReasonOption' attribute.
                eventTypeReason: "=", // Two-way binding for the 'eventTypeReason' attribute.
                eventExplanation: "=", // Two-way binding for the 'eventExplanation' attribute.
                explanationMinChar: "=", // Two-way binding for the 'explanationMinChar' attribute.
                explanationShowLabel: "=" // Two-way binding for the 'explanationShowLabel' attribute.
            }
        };
    });
}

/**
 * Controller for the 'adminEventType' directive.
 * 
 * @class AdminEventTypeController
 * @param {object} $scope - AngularJS scope object.
 * @param {object} $filter - AngularJS filter service.
 * @param {object} $bridges - Custom service for bridge functionalities.
 * @param {object} $signals - Custom service for signal functionalities.
 * @param {object} TaskInfoService - Service for retrieving task information.
 */
class AdminEventTypeController {
    constructor($scope, $filter, $bridges, $signals, TaskInfoService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$bridges = $bridges;
        this.$signals = $signals;
        this.TaskInfoService = TaskInfoService;

        this.$scope._logIdentifier = 'AdminEventTypeController';
        this.$logger = this.$bridges.logger();

        // Initialize eventExplanationValue from the bound eventExplanation
        this.$scope.eventExplanationValue = this.$scope.eventExplanation || '';

        // Watch for external changes to eventExplanation
        this.$scope.$watch('eventExplanation', (newVal) => {
            if (newVal !== this.$scope.eventExplanationValue) {
                this.$scope.eventExplanationValue = newVal;
            }
        });

        // Watch for changes to eventExplanationValue
        this.$scope.$watch('eventExplanationValue', (newVal, oldVal) => {
            if (newVal !== oldVal) {
                this.onChangeUpdateParent('explanation');
            }
        });

        // Bind methods to the controller instance.
        this.reasonDefault = this.reasonDefault.bind(this);
        this.onChangeUpdateParent = this.onChangeUpdateParent.bind(this);
        this.init = this.init.bind(this);

        this.init();
    }

    /**
     * Sets the default reason based on the current scope values.
     * 
     * @method reasonDefault
     */
    reasonDefault() {
        // SMELL: The condition is complex and could be refactored for better readability.
        if ((this.$scope.emptyReasonOption && this.$scope.filteredEventType.reasonPickList) || (typeof this.$scope.filteredEventType !== 'undefined' && this.$scope.filteredEventType.reasonPickList)) {
            if (this.$scope.eventTypeReason) {
                this.$scope.selectedEventTypeReason = this.$scope.eventTypeReason;
            } else if (this.$scope.emptyReasonOption) {
                this.$scope.selectedEventTypeReason = "";
            } else {
                this.$scope.selectedEventTypeReason = this.$scope.filteredEventType.reasonPickList[0].id;
            }
        }
    }

    /**
     * Updates the parent scope based on the changed value.
     * 
     * @method onChangeUpdateParent
     * @param {string} index - The index of the changed value.
     */
    onChangeUpdateParent(index) {
        
        if (index === 'explanation') {
            if (angular.isDefined(this.$scope.eventExplanationValue)) {
                if (this.$scope.eventExplanationValue.length > 4000) {
                    if (this.$scope.eventExplanation && 
                        this.$scope.eventExplanation.length === 4000) {
                        this.$scope.eventExplanationValue = this.$scope.eventExplanation;
                        return false;
                    }
                    this.$scope.eventExplanationValue = this.$scope.eventExplanationValue.substring(0, 4000);
                }
                
                this.$scope.eventExplanation = this.$scope.eventExplanationValue;
                
                // Force digest if needed
                if (!this.$scope.$$phase && !this.$scope.$root.$$phase) {
                    this.$scope.$apply();
                }
            }
        }
        if (index === 'eventTypeReason') {
            if (!angular.isDefined(this.$scope.selectedEventTypeReason)) {
                this.$scope.selectedEventTypeReason = "";
            }
            this.$scope.eventTypeReason = this.$scope.selectedEventTypeReason;
        }
    }

    /**
     * Initializes the controller by setting up the initial state.
     * 
     * @method init
     */
    init() {
        this.$scope.eventTypes = angular.copy(this.TaskInfoService.getTaskInfo().getEventTypes());
        if (angular.isDefined(this.$scope.eventId)) {
            this.$scope.filteredEventType = this.$filter('filter')(this.$scope.eventTypes, {id: this.$scope.eventId}, true)[0];
        } else if (angular.isDefined(this.$scope.type)) {
            this.$scope.filteredEventType = this.$filter('filter')(this.$scope.eventTypes, {type: this.$scope.type}, true)[0];
        }

        if (this.$scope.filteredEventType) {
            if (this.$scope.filteredEventType.explanatoryNote === 'off') {
                this.$scope.explanatoryNoteShow = false;
                this.$scope.eventExplanation = false;
            } else if (this.$scope.filteredEventType.explanatoryNote === 'mandatory') {
                this.$scope.explanatoryNoteShow = true;
                this.$scope.explanatoryNoteMandatory = true;
            } else if (this.$scope.filteredEventType.explanatoryNote === 'optionalDuringExam' ||
                      this.$scope.filteredEventType.explanatoryNote === 'optional') {
                this.$scope.explanatoryNoteShow = true;
            } else {
                this.$scope.explanatoryNoteShow = false;
                this.$scope.eventExplanation = false;
            }

            if (this.$scope.filteredEventType.reasonPickList && this.$scope.emptyReasonOption) {
                this.$scope.filteredEventType.reasonPickList.unshift({
                    id: "",
                    reason: "-"
                });
            }
            this.reasonDefault();
        }
    }
}

AdminEventTypeController.$inject = ['$scope', '$filter', '$bridges', '$signals', 'TaskInfoService'];